<template>

  <el-dialog title="添加成员" :visible.sync="centerDialogVisible" width="80%" @close="handleClose">
    <div class="search-box" style="display:inline-block; width:200px;padding-bottom:20px;">

      <el-input v-model="searchContent" placeholder="请输入内容" clearable />
    </div>
    <div class="search-box" style="display:inline-block;padding-left:10px;">
      <el-button type="primary" @click="search">搜索</el-button>
     
    </div>

    <transition name="addFade">
      <div style="position: relative">
          <div class="addtip" v-show="tipFlag">
              <i class="tipIcon"></i>已选中<span class="data">{{ dataCount }}</span>项
            </div>
          </div> 
      </transition>
    <div class="tableAnimate">
      <el-table ref="multipleTable" :data="tableDataFile" tooltip-effect="dark" style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column prop="idx" label="序号" width="60" />
        <el-table-column prop="code" label="员工工号" width="120" />
        <el-table-column prop="name" label="员工姓名" width="120" />
        <el-table-column :show-overflow-tooltip="true" label="性别">
          <template slot-scope="scope">
            <P v-if="scope.row.sex==1">女</P>
            <P v-else>男</P>
          </template>

        </el-table-column>
        <el-table-column prop="graduatedSchool" label="毕业院校" show-overflow-tooltip />
        <el-table-column prop="education" label="学历" show-overflow-tooltip />
        <el-table-column prop="censusAddress" label="户籍地址" show-overflow-tooltip />
      </el-table>
      <div class="mt10">
        <el-pagination :current-page="pageInfo.currentPage" :page-sizes="pageInfo.pageSizeList"
          :page-size="pageInfo.limit" layout="total, prev, pager, next, jumper" :total="pageInfo.allCount"
          @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </el-pagination>
      </div>
    </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="centerDialogVisible = false">取 消</el-button>
      <el-button :disabled="isAble" type="primary" @click="handleAdd">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import jq from "jquery"
  import { personList, addUser, undistributedUser } from '@/api/system'
  export default {
    props: ['currentgroup', 'addId'],
    data() {
      return {
        currentGroup: this.currentgroup,
        pageInfo: {
          limit: 10,
          allCount: 0,
          currentPage: 1,
          currentPageCount: 0,
          showEdit: false // 是否显示快捷编辑代码框
        },
        searchContent: '',
        centerDialogVisible: true,
        tableData: [],
        multipleSelection: [],
        addData: {},
        dataCount: 0,
        tipFlag: false
      }
    },
    computed: {
      tableDataFile() {
        const _this = this
        _this.tableData.forEach((item, idx) => {
          item.idx = idx + 1
        })
        return _this.tableData
      },
      isAble() {
        let result = true
        if (this.multipleSelection.length) {
          result = false
        }
        return result
      }
    },
    watch: {
      multipleSelection: {
        deep: true,
        handler: function (val, old) {
          if (this.multipleSelection.length > 0) {

            this.tipFlag = true
            this.tipEnter()
          } else {
            this.tipFlag = false
            this.tipLeave()
          }
          this.dataCount = this.multipleSelection.length
        }
      }
    },
    mounted() {
      this.fetchData()
    },
    methods: {
      fetchData() {
        const _this = this
        undistributedUser({
          searchKey: _this.searchContent,
          pageNo: _this.pageInfo.currentPage,
          pageSize: _this.pageInfo.limit
        }).then(res => {
          if (res && res.code == 0) {
            // this.type = res.data[0].type
            // this.info = res.data[0]
            _this.pageInfo.allCount = res.data.total
            _this.tableData = res.data.items
          }
        })
      },
      handleAdd() {
        var str = ''
        for (var i = 0; i < this.multipleSelection.length; i++) {
          if (i == 0) {
            str += this.multipleSelection[0].id
          } else {
            str += ',' + this.multipleSelection[i].id
          }
        }
        console.log(this.officeId)
        addUser({
          officeId: this.addId,
          ids: str
        }).then(res => {
          if (res && res.code == 0) {
            this.$message.success('添加成功')
            this.$emit('closeDialog', false)
            this.$emit('returnResult')
          }
        })
        // window.console.log(JSON.stringify(this.currentGroup))
        // window.console.log(JSON.stringify(this.multipleSelection))
      },
      handleClose: function () {
        this.$emit('closeDialog', false)
      },
      search() {
        this.pageInfo.currentPage = 1
        this.fetchData()
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      handleSizeChange(val) {
        this.pageInfo.limit = val
        this.pageInfo.currentPage = 1
        this.fetchData()
      },
      handleCurrentChange(val) {
        this.pageInfo.currentPage = val
        this.fetchData()
      },
      tipEnter() {
        jq(".tableAnimate").addClass('leave')
        jq(".tableAnimate").removeClass('enter')
      },
      tipLeave() {
        jq(".tableAnimate").addClass("enter")
        jq(".tableAnimate").removeClass('leave')
      }
    }
  }
</script>
<style lang="scss" scoped>
  /deep/.el-dialog__body {
    overflow: hidden;
    margin-bottom: -5px !important;
  }

  .enter {
    top: 0px !important;
  }

  .leave {
    top: 34px !important;
  }

  .tipIcon {
    width: 14px;
    height: 14px;
    display: inline-block;
    background-size: contain;
    background-image: url("../../../../assets/Shape.png");
    margin-right: 8px;
    position: relative;
    top: 3px;
  }

  .mt10 {
    margin-top: 10px !important;
    float: right;
    margin-bottom:32px;
  }

  /deep/.el-dialog__footer {
    /* padding-top: 30px; */
  }

  .addtip {
    background-color: #FFFAF5;
    padding: 8px 0px 8px 16px;
    margin-bottom: 8px;
    color: rgba(0, 0, 0, 0.65);
    font-size: 12px;
    position: absolute;
    top: -9px;
    width: 100%;
   
  }

  .addFade-enter,
  .addFade-leave-to {
    opacity: 0;
    transform: translateY(20px);
  }

  /* v-enter-active 【入场动画的时间段】 */
  /* v-leave-active 【离场动画的时间段】 */
  .addFade-enter-active,
  .addFade-leave-active {
    transition: all 0.5s ease;
  }

  .data {
    color: #FFA940;
  }

  /deep/.el-table td {
    padding: 0px !important;
  }
  .tableAnimate {
  margin: 0 auto;
  position: relative;
  top:0px;
  transition: all  0.3s ease;
}
</style>